export function upcomingBlock() {
    function resizeOffset() {
        $(".upcoming-block").each(function () {
            let etalonOffset = $(this).find(".for-js").offset().left;
            let offsetBlock = $(this).find(".upcoming-block-holder");
            $(offsetBlock).css("padding-left", etalonOffset);
        });
    }
    $(window).on("load resize", resizeOffset);

    $(".upcoming-slider").slick({
        infinite: false,
        variableWidth: false,
        appendArrows: ".upcoming-block-sl-controll",
        arrows: true,
        slidesToShow: 2.67,
        prevArrow: "<div class='sl-btn sl-btn--prev'><svg viewBox='0 0 31 12' xmlns='http://www.w3.org/2000/svg'><path d='m0 6 10 5.774V.226L0 6Zm30 1a1 1 0 1 0 0-2v2ZM9 7h21V5H9v2Z'/></svg></div>",
        nextArrow: "<div class='sl-btn sl-btn--next'><svg viewBox='0 0 31 12' xmlns='http://www.w3.org/2000/svg'><path d='M1 5a1 1 0 0 0 0 2V5Zm30 1L21 .226v11.547L31 6ZM1 7h21V5H1v2Z'/></svg></div>",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.17,
                    appendArrows: ".upcoming-block-sl-controll-mob",
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.5,
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 2.59,
                }
            },
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/upcoming-block.js